import { useEffect } from "react";
import { API_CASINO } from "../../api/casino";
import { useAppSelector } from "../../store/index.ts";
import { useDispatch } from "react-redux";
import {
  setCategoryList,
  setCategoryLoading,
  setFillCategoryById
} from "../../store/gamesSlice.js";
import { setCollectionId } from "../../store/commonSlice.js";
import { useLocalStorage } from "usehooks-ts";
import { ENUM_LCS_NAME, GAME_COUNT } from "../../store/enums.js";
import { getSecondByMinutes } from "../../utils/utils.js";

// const MINUTES = 60;
const MINUTES = 0.1;
const defaultSaveCat = { categoryList: [], currency: "", collectionId: 0, time: undefined };

export default function useCollection() {
  const dispatch = useDispatch();
  const currency = useAppSelector((state) => state.user.currency);
  const collectionHash = useAppSelector((state) => state.common.collectionList);

  const [saveCategory, setSaveCategory] = useLocalStorage(ENUM_LCS_NAME.categories, defaultSaveCat);

  const collectionListSt = Object.keys(collectionHash).join(",");

  const fillCategoryById = (categories) => {
    const categoryById = categories.reduce((prev, cur) => {
      prev[cur.id] = cur;
      return prev;
    }, {});
    dispatch(setFillCategoryById(categoryById));
  };

  useEffect(() => {
    const collectionIds = Object.keys(collectionHash);
    console.log("currency", currency, collectionIds);

    if (!currency) return;
    if (!collectionIds.length) return;

    let isAnyCurrencyId = null;
    let currentCollectionId = null;
    dispatch(setCategoryLoading(true));

    collectionIds.forEach((collectionId) => {
      const collection = collectionHash[collectionId];
      if (collection.currencyList.length == 0) {
        isAnyCurrencyId = collectionId;
      }
      if (collection.currencyList.includes(currency)) {
        currentCollectionId = collectionId;
      }
    });

    if (!currentCollectionId) currentCollectionId = isAnyCurrencyId;
    if (!currentCollectionId) {
      dispatch(setCategoryLoading(false));
      dispatch(setCategoryList([]));
      return;
    }

    dispatch(setCollectionId(+currentCollectionId));
    const equalCollectId = saveCategory.collectionId == currentCollectionId;
    const equalCurrency = saveCategory.currency == currency;

    if (equalCurrency && equalCollectId) {
      if (+saveCategory?.time + getSecondByMinutes(MINUTES) > +new Date()) {
        if (saveCategory.collectionId) {
          const categoryList = saveCategory.categoryList;

          dispatch(setCollectionId(saveCategory.collectionId));
          dispatch(setCategoryList(categoryList));
          dispatch(setCategoryLoading(false));
          fillCategoryById(categoryList);
          return;
        }
      }
    } else {
      setSaveCategory(defaultSaveCat);
    }

    API_CASINO.list
      .collection({ collectionId: +currentCollectionId, maxGames: GAME_COUNT * 2 })
      .then((e) => {
        const categoryList = e.data.categoryList;
        dispatch(setCategoryList(categoryList));
        if (categoryList.length) {
          setSaveCategory({
            categoryList,
            time: +new Date(),
            currency,
            collectionId: +currentCollectionId
          });
        }
        fillCategoryById(categoryList);
      })
      .catch(console.error)
      .finally(() => dispatch(setCategoryLoading(false)));
  }, [currency, collectionListSt]);
}
